import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        products: false
      },
      options: {
        products: []
      },
      selected: {
        product: ''
      },
      editable: {
        product: ''
      }
    }
  },

  methods: {

    async getProducts (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.product
      const fetching = context.fetching?.products
      const options = context.options?.products

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.products = true
      context.selected.product = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getProducts(filters).then(
        ({ data }) => {
          context.options.products = data.map(
            ({ id, category, product_code, product_name }) => ({
              id: id,
              category_id: category.id,
              category_code: category.category_code,
              category_name: category.category_name,
              group_code: category.group?.group_code || '',
              group_name: category.group?.group_name || '',
              product_code: product_code,
              product_name: product_name
            })
          )
        }
      ).catch(() => {
        context.options.products = []
      }).finally(() => {
        context.fetching.products = false
      })
    },

    async searchProducts (search, loading) {
      this.searchProductsProvider(this, search, loading)
    },

    searchProductsProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.products, {
          keys: ['product_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getProducts(filters).then(
            ({ data }) => {
              options.products = data.map(
                ({ id, category, product_code, product_name }) => ({
                  id: id,
                  category_id: category.id,
                  category_code: category.category_code,
                  category_name: category.category_name,
                  group_code: category.group?.group_code || '',
                  group_name: category.group?.group_name || '',
                  product_code: product_code,
                  product_name: product_name
                })
              )
            }
          ).catch(() => {
            options.products = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
